import { mapState } from 'vuex';

export default {
    name: 'story_listpreview',
    props: {
        story : Object
    },

    data : function(){

        return {
        }

    },

    created(){

    },

    watch: {
        
    },
    
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {

    },
}